import {compose} from 'redux';
import {connect} from 'react-redux';

import { 
  fetchSubscription, 
  doUpdateSubscription, 
  doCancelSubscription, 
  doReactivateSubscription 
} from "../actions/subscriptions";
import { withNavigation } from '../actions/navigation';

/**
 * Higher Order Component to manage subscriptions
 */

const mapStateToProps = ({ subscriptionsById, productsById }, { subscriptionId }) => {
  const subscription = subscriptionsById[subscriptionId];

  // FIXME: remove
  const product = subscription 
    && subscription.plan 
    && productsById[subscription.plan.product.id];

  return {    
    subscription,
    product,    
  };
};

const mapDispatchToProps = (dispatch, { 
  subscriptionId, 
  navigateToSubscription, 
  navigateToSubscriptionEdit 
}) => ({
  loadSubscription: () =>
    dispatch( fetchSubscription(subscriptionId) ),

  updateSubscription: ({ plan, licencesCount }) =>
    dispatch( doUpdateSubscription(subscriptionId, plan.id, licencesCount) ),

  cancelSubscription: () =>
    dispatch( doCancelSubscription( subscriptionId ) ),

  reactivateSubscription: () =>
    dispatch( doReactivateSubscription( subscriptionId ) ),

  viewSubscription: () => 
    navigateToSubscription(subscriptionId),

  editSubscription: () => 
    navigateToSubscriptionEdit(subscriptionId),
    
});

export const withSubscription = compose(
  withNavigation,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);


// WEBPACK FOOTER //
// ./src/containers/withSubscription.js